import React, { useState, useEffect } from 'react'
import "./MeasurementUnit.scss"
import Modal from "../../../layouts/Modal/Modal"
import Axios from "middleware/axiosInstance";
import Loading from '../../../layouts/Loading/Loading'
import ButtonComponent from '../../../components/Form/ButtonComponent'
import InputComponent from '../../../components/Form/InputComponent'
import OpenNotificationWithIcon from 'layouts/notificationWithIcon/OpenNotificationWithIcon ';

const MeasurementUnit = () => {
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [newMeasurement, setNewMeasurement] = useState({})
  const [editeMeasurement, setEditeMeasurement] = useState({})
  const [allCorrentMeasurementUnit, setAllCorrentMeasurementUnit] = useState(null)

  const CreateMeasurementUnitHandler = (e) => {
    e.preventDefault();
    // const [posts, error, loading, axiosFetch] = useAxiosFunction();
    // axiosFetch({
    //   method: 'post',
    //   url: '/v_sanjesh',
    //   requestConfig: newMeasurement
    // }).then((res) => console.log(res)).catch(err => console.log(err))
    // error && console.log(error.response.data)
    // posts && console.log(posts)
    Axios.post(`v_sanjesh`, newMeasurement)
      .then((res) => {
        console.log(res)
        OpenNotificationWithIcon("ثبت موفق", "واحد اندازه گیری جدید با موفقیت ثبت شد")
        setNewMeasurement(null)
        getAllMeasurementUnit()
      }).catch((err) => {
        console.log(err.response.status)
        OpenNotificationWithIcon("خطا", "واحد اندازه گیری جدید ثبت نشد", "error")
      })
      .finally(() => {

        setShowAddModal(false)
      })

  }
  const editeMeasurementUnitHandler = () => {
    Axios.put(`v_sanjesh/${selectedItem.id}`, editeMeasurement)
      .then((res) => {
        console.log(res);
        getAllMeasurementUnit();
        OpenNotificationWithIcon("ویرایش", "واحد اندازه گیری ویرایش شد")
      })
      .catch(() => {
        OpenNotificationWithIcon("خطا", "واحد اندازه گیری ویرایش نشد", "error")
      })
      .finally(() => {
        setShowEditModal(false)
        setSelectedItem(null)
        setEditeMeasurement(null)
      }
      )
  }

  const getAllMeasurementUnit = () => {
    Axios.get("v_sanjesh")
      .then((res) => {
        setAllCorrentMeasurementUnit(res.data)
      })
      .catch(() => {
        OpenNotificationWithIcon("خطا در دیافت اطلاعات", "لیست واحد های اندازه گیری دریافت نشد", "error")
        // alert("لیست واحد های اندازه گیری دریافت نشد")
      })
  }

  const deleteMeasurementUnitHandler = () => {
    Axios.delete(`v_sanjesh/${selectedItem.id}`)
      .then((res) => {
        console.log(res);
        getAllMeasurementUnit();
        setShowAddModal(false)
        OpenNotificationWithIcon("موفق", "واحد اندازه گیری حذف شد")
      })
      .catch(() => {
        alert("واحد اندازه گیری حذف نشد!")
        OpenNotificationWithIcon("خطا", "واحد اندازه گیری حذف نشد", "error")
      })
      .finally(() => {
        setSelectedItem(null)
      })
  }


  useEffect(() => {
    getAllMeasurementUnit();
  }, []);


  const handleSelectRow = (item) => {
    setSelectedItem(item)
  }

  // const editItemHandler = () => {
  //   console.log(selectedItem);
  // }

  const deleteItemHandler = () => {
    if (window.confirm(`آیا واحد اندازه گیری "${selectedItem.name}"  حذف گردد؟ \n\n هشدار: \n تمام کالاهای مربوط به این واحد اندازه گیری نیز حذف می گردد!\n و اسناد ثبت شده شامل این کالاها نیز حذف می گردند!`)) {
      deleteMeasurementUnitHandler();
    }
  }

  const changeInputHandler = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    setNewMeasurement({ ...newMeasurement, [name]: value });
  }

  const changeEditeHandler = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    setEditeMeasurement({ ...editeMeasurement, [name]: value });
  }






  return (
    <div className="customized-container">
      <div className="customized-wrapper">
        {showAddModal && <Modal >
          {/* <InputForm name button textarea /> */}
          <form className='p-4'>

            <h6 className='text-center mt-2'>
              ایجاد یک واحد اندازه گیری:
            </h6>
            <InputComponent
              lableValue="نام:"
              inputType="text"
              onChange={changeInputHandler}
              inputName="name"
              inputPlaceholder="کیلوگرم"
            />
            <InputComponent
              lableValue="تعداد اعشار:"
              inputType="number"
              onChange={changeInputHandler}
              inputName="tedad_ashar"
              inputPlaceholder="3"
            />
            {/* <TextAreaComponent
              lableValue="توضیحات:"
              onChange={changeInputHandler}
              textareaName="description"
            /> */}
            <div className='d-flex justify-content-evenly  flex-wrap mt-4'>

              <ButtonComponent value="ثبت" onClick={(e) => CreateMeasurementUnitHandler(e)} />
              <ButtonComponent value="انصراف" onClick={() => setShowAddModal(false)} />
            </div>
          </form>
        </Modal>}

        {showEditModal && <Modal >
          <div className='p-4'>

            <h6 className='text-center mt-2'>
              ویرایش واحد اندازه گیری

              {` ${selectedItem.name}: `}
            </h6>
            <InputComponent
              lableValue="نام:"
              inputType="text"
              onChange={changeEditeHandler}
              inputName="name"
              defaultValue={selectedItem.name}
            />
            <InputComponent
              lableValue="تعداد اعشار:"
              inputType="number"
              onChange={changeEditeHandler}
              inputName="tedad_ashar"
              defaultValue={selectedItem.tedad_ashar}
            />
            {/* <TextAreaComponent
            lableValue="توضیحات:"
            onChange={changeEditeHandler}
            defaultValue={selectedItem.description}
          /> */}
            <div className='d-flex justify-content-evenly  flex-wrap mt-4'>
              <ButtonComponent value="ثبت" onClick={() => editeMeasurementUnitHandler()} />
              <ButtonComponent value="انصراف" onClick={() => setShowEditModal(false)} />
            </div>
          </div>
        </Modal>}

        <h5 className="title-session">
          واحدهای اندازه گیری
        </h5>



        <div className='d-flex flex-row '>

          <button className='bi-custom-button'
            onClick={() => setShowAddModal(true)}
          >اضافه کردن</button>

          <button className='bi-custom-button'
            onClick={() => selectedItem ? setShowEditModal(true) :
              //  alert("جهت ویرایش  یک آیتم را انتخاب فرمایید!")
              OpenNotificationWithIcon("خطا", "جهت ویرایش  یک آیتم را انتخاب فرمایید", "error")
            }
          >ویرایش</button>
          <button className='bi-custom-button'
            onClick={() => selectedItem ? deleteItemHandler() :
              OpenNotificationWithIcon("خطا", "جهت حذف  یک آیتم را انتخاب فرمایید", "error")

              // alert("جهت حذف یک آیتم را انتخاب فرمایید!")
            }
          >حذف</button>
        </div>
        <>
          {allCorrentMeasurementUnit === null ?
            <Loading />
            :
            // allCorrentMeasurementUnit.length === 0 ?

            //   <h1>
            //     واحد اندازه گیری تعریف نشده است
            //   </h1>
            //   :
            <table className="bi-table-style bi-row-select-enable col-12 col-md-6 col-lg-4">
              <thead>
                <tr>
                  <th >ردیف</th>
                  <th >نام</th>
                  <th >تعداد اعشار</th>
                  {/* <th >توضیحات</th> */}
                </tr>
              </thead>
              <tbody>
                {allCorrentMeasurementUnit.map((measurementUnit, index) => {
                  return (
                    <tr id={measurementUnit.id}
                      onClick={() => handleSelectRow(measurementUnit)}
                      className={selectedItem?.id === measurementUnit.id ? "item-slected" : null}>
                      <td >
                        {index + 1}
                        {/* {measurementUnit.code} */}
                      </td>
                      <td>
                        {measurementUnit.name}
                      </td>
                      <td >
                        {measurementUnit.tedad_ashar}
                      </td>
                      {/* <td >
                        {measurementUnit.description}
                      </td> */}
                    </tr>
                  )
                })}
              </tbody>
            </table>
          }
        </>
      </div>
    </div>
  )
}
export default MeasurementUnit